<template>
	<div id="event2" :style="{height:bodyHeight+'px'}">
		<div style="height: 50px;width: 100%;" class="middle-row center"><span style="font-size: 30px;">街道事件中心</span></div>
		<div style="height: 50px;width: 100%;" class="middle-row around nowarp">
			<span :class="index==streetindex?'e2active':''" class="event2_title middle-row center" style="" v-for="(street,index) in streets" :key='index' @click="getEventMerchant(index)">
				{{street._id}}
			</span>
		</div>
		<div :style="{height:contentHeight+'px'}" style="margin: 10px;background-color: white;" class="middle-row around ebody">
			<div class="merchants" style="height: 100%;overflow-y: scroll;">
				<div class="merlist middle-row around" v-for="(mer,index) in merchants" :key="index" @click="selectMerchant(index)">
					<div style="width: 60%;font-weight:bold;">{{mer._id}}</div>
					<div style="width: 10%;font-weight:bold;">{{mer.count}}</div>
					<div style="width: 30%;">
						<button type="button" class="btn btn-sm" style="background-color:#574b90;color: white;" @click="toGroup(index)">批量处理</button>
					</div>
				</div>
			</div>
			<div class="events">
				<div :style="{height:contentHeight-70+'px'}">
					<table class="table" style="background-color: white;">
						<thead>
							<tr>
								<th v-for="(th,index) in tablelist2" :key='index'>{{th}}</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(eve,index) in events" :key='index'>
								<td>{{index+(pageIndex*12)+1}}</td>
								<td>{{eve.merchantName}}</td>
								<td>{{timelist[index]}}</td>
								<td v-if="eve.eventName != '24小时内未开机'">{{Object.keys(eve.values[0])[0]}}</td>
								<td v-else>{{eve.eventName}}</td>
								<td v-if="eve.eventName != '24小时内未开机'">{{Object.values(eve.values[0])[0]}}</td>
								<td v-else>--</td>
								<td v-if="eve.eventName != '24小时内未开机'">{{Object.values(eve.standards[0])[0]}}</td>
								<td v-else>--</td>
								<td v-if="eve.state">已处理</td>
								<td v-if="!eve.state">未处理</td>
								<td v-if="eve.state">
									<button type="button" class="btn btn-sm btn-success" @click="todetail(index)" >查看</button>
								</td>
								<td v-if="!eve.state">
									<button type="button" class="btn btn-sm btn-warning" @click="todetail(index)" >处理</button>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div style="height: 50px;background-color: red;width: 100%;background-color: white;" class="middle-row center">
					<ul class="pagination pagination" v-if="pageTotal<=5">
						<li><a href="#" @click="tofirst">首页</a></li>
						<li><a href="#" @click="laquo">&laquo;</a></li>
						<li v-for="n in pageTotal" :key="n"><a href="#" @click="pageClick(n)">{{n}}</a></li>
						<li><a href="#" @click="raquo">&raquo;</a></li>
						<li><a href="#" @click="tolast">尾页</a></li>
					</ul>
					<ul class="pagination pagination" v-if="pageTotal>=6">
						<li><a href="#" @click="tofirst">首页</a></li>
						<li><a href="#" @click="laquo">&laquo;</a></li>
						<li><a href="#" @click="pageClick(1)">1</a></li>
						<li><a href="#" @click="pageClick(2)">2</a></li>
						<li><a href="#">...</a></li>
						<li><a href="#" @click="pageClick(pageTotal-1)">{{pageTotal-1}}</a></li>
						<li><a href="#" @click="pageClick(pageTotal)">{{pageTotal}}</a></li>
						<li><a href="#" @click="raquo">&raquo;</a></li>
						<li><a href="#" @click="tolast">尾页</a></li>
					</ul>
					<span style="margin-left: 10px;">共<b>{{pageTotal}}</b>页，当前第<b>{{pageIndex+1}}</b>页，转跳至第<input type="text" v-model="topage"
						 @keydown.enter="skipto" style="margin: 5px;text-align: center;" size="1" /> 页</span>
				</div>
			</div>
		</div>
		<div class="modal fade" id="eventModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
		    <div class="modal-dialog" style="height:80%;width:100%;margin: 0px;">
		        <div class="modal-content clearfix"  style="height:100%;width:100%;">
		            <div class="modal-header">
		                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
		                <h4 class="modal-title" id="myModalLabel">事件处理中心</h4>
		            </div>
		            <div class="modal-body" style="position: absolute;top: 56px;bottom: 65px;width: 100%;">
						<table class="table" style="font-size: 15px;font-weight: bold;">
							<thead>
								<tr>
									<th v-for="(item,index) in tablelist3" :key="index">{{item}}</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>{{eve.eventName}}</td>
									<td>{{eve.merchantName}}</td>
									<td>{{timelist[index]}}</td>
									<td>
										<div v-for="i in eve.count" :key="i">{{Object.keys(eve.values[i-1])[0]}}</div>
									</td>
									<td>
										<div style="color: red;font-weight: bold;" v-for="i in eve.count" :key="i">{{Object.values(eve.values[i-1])[0]}}</div>
									</td>
									<td>
										<div style="color: green;font-weight: bold;" v-for="i in eve.count" :key="i">{{Object.values(eve.standards[i-1])[0]}}</div>
									</td>
									<td v-if="eve.state">
										已处理
									</td>
									<td v-if="!eve.state">
										未处理
									</td>
								</tr>
							</tbody>
						</table>
						<hr/>
						<div style="width: 100%;" class="middle-row around">
							<div class="middle-column around" style="width:48%;height: 400px;">
								<div class="input-group" >
									<span class="input-group-addon">事件处理过程</span>
									<textarea style="font-size: 20px;" v-model="eve.detail" cols="20" rows="5"  class="form-control" id="process" /></textarea>
								</div>
								<div class="middle-row around wrap" style="width: 100%;">
									<img width="100px" v-for="(img,index) in imgs" :key="index" :src="img.imgPath" alt="" @click="bigImg(index)">
								</div>
							</div>
							
							<div style="width:48%">
								<baidu-map class="bm-view" :zoom="14" :center="{lng:longitude,lat:latitude}"  ak="OydBLLOIYzqXFEIoDNyBKM5lVuNYhucB"
								 :scroll-wheel-zoom='true' style="height: 400px;">
									<bm-marker :title="merchant.merchantName" :position="{lng:longitude,lat:latitude}" :dragging="false" animation="BMAP_ANIMATION_BOUNCE">
									</bm-marker>
								</baidu-map>
							</div>
						</div>
					</div>
		            <div class="modal-footer" style="position: absolute;bottom: 0px;width: 100%;">
		                <button type="button" class="btn btn-default" data-dismiss="modal">关闭</button>
		                <button type="button" class="btn btn-primary" @click="submitDetail">提交处理</button>
		            </div>
		        </div><!-- /.modal-content -->
		    </div><!-- /.modal -->
		</div>
		
		<div class="bigimg" v-show="isShow" @click="closeImg">
			<img height="100%"  :src="path" alt="" style="padding: 10px 0px;">
		</div>
		
		<div class="modal fade" id="eventGroup" tabindex="-1" role="dialog" aria-labelledby="group" aria-hidden="true">
		    <div class="modal-dialog">
		        <div class="modal-content">
		            <div class="modal-header">
		                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
		                <h4 class="modal-title" id="group">{{merchant._id}}--批量处理</h4>
		            </div>
		            <div class="modal-body">
						<textarea style="font-size: 20px;" v-model="detail" cols="20" rows="10"  class="form-control" id="process2" /></textarea>
					</div>
		            <div class="modal-footer">
		                <button type="button" class="btn btn-default" data-dismiss="modal">关闭</button>
		                <button type="button" class="btn btn-primary" @click="groupSubmit">提交更改</button>
		            </div>
		        </div><!-- /.modal-content -->
		    </div><!-- /.modal -->
		</div>
	</div>
</template>	

<script>
	import {util} from '../../static/util.js'
	import {BaiduMap,BmMarker,BmCircle,BmBoundary} from 'vue-baidu-map'
	export default({
		data(){
			return{
				bodyHeight:0,
				streets:[],
				street:'',
				streetindex:0,
				merchants:'',
				merchantName:'',
				merchant:'',
				contentHeight:0,
				pageIndex:0,
				events:[],
				tablelist2: ['序号','所属企业', '发生时间','超标内容', '超标值', '标准值','是否处理','查看处理'],
				tablelist3: ['序号','所属企业', '发生时间','超标内容', '超标值', '标准值','是否处理'],
				pageTotal:0,
				topage:0,
				timelist:[],
				processtimelist:[],
				eve:'',
				detail:'',
				longitude:'',
				latitude:'',
				index:'',
				imgs:[],
				path:'',
				isShow:false
				
			}
		},
		mounted() {
			this.bodyHeight = this.GLOBAL.bodyHeight;
			this.contentHeight = this.bodyHeight-135;
			this.$http.get(this.GLOBAL.base+'eventStreet').then(function(msg) {
				this.streets = msg.body;
				this.street=this.streets[0]._id;
				this.$http.get(this.GLOBAL.base+'getEventByStreetGroup2',{params:{street:this.street}}).then(function(msg) {
					this.merchants = msg.body;
					this.pageTotal=Math.ceil(this.merchants[0].count/12);
					this.merchantName=this.merchants[0]._id;
					this.getEventByName();
				})
			})
		},
		methods:{
			getEventMerchant(index){
				this.streetindex = index;
				this.street = this.streets[index]._id;
				this.$http.get(this.GLOBAL.base+'getEventByStreetGroup2',{params:{street:this.street}}).then(function(msg) {
					this.merchants = msg.body;
					this.pageTotal=Math.ceil(this.merchants[0].count/12);
					this.merchantName=this.merchants[0]._id;
					this.getEventByName();
				})
			},
			getEventByName(){
				this.$http.get(this.GLOBAL.base+'getEventByName2',{params:{name:this.merchantName,index:this.pageIndex}}).then(function(msg) {
					this.events = msg.body;
					this.timelist=[];
					for (let eve of this.events) {
						if(eve.eventName == '24小时内未开机'){
							this.timelist.push(util.timeToStringForOffline(eve.time));
						}else{
							this.timelist.push(util.timeToStringWithMonth(eve.time));
						}
					}
				})
			},
			bigImg:function (index) {
				this.path = this.imgs[index].imgPath;
				console.log(this.path)
				this.isShow=true;
			},
			closeImg:function() {
				this.isShow=false;
			},
			toGroup(index){
				this.merchant = this.merchants[index];
				$("#eventGroup").modal("show");
			},
			groupSubmit:function() {
				if(this.detail==''){
					alert('处理过程不能为空')
				}else{
					this.$http.get(this.GLOBAL.base+'updateEventGruop',{params:{name:this.merchant._id,detail:this.detail}}).then(function (msg) {
						alert("批量处理成功！");
						this.getEventByName();
						$("#eventGroup").modal("hide");
					})
				}
			},
			submitDetail:function() {
				this.$http.get(this.GLOBAL.base+'updateEvent',{params:{time:this.eve.time,detail:this.eve.detail}}).then(function(msg) {
					this.events[this.index] = msg.body;
					alert("处理成功");
					this.getEventByName();
				})
			},
			todetail:function (index) {
				this.eve = this.events[index];
				this.index = index;
				this.$http.get(this.GLOBAL.base+'getMerchantByEquId',{params:{equId:this.eve.equId}}).then(function (msg) {
					this.merchant = msg.body;
					this.latitude = this.merchant.latitude;
					this.longitude = this.merchant.longitude;
					$("#eventModal").modal("show");
				});
				this.$http.get(this.GLOBAL.base+'getEventImages',{params:{eventId:this.eve.id}}).then(function(msg) {
					this.imgs = msg.body;
				})
			},
			selectMerchant(index){
				this.merchantName = this.merchants[index]._id;
				this.pageTotal=Math.ceil(this.merchants[index].count/12);
				this.getEventByName();
			},
			pageClick:function(n) {
				this.topage=n;
				this.skipto();
			},
			skipto: function() { //跳转至指定页面
				var numReg = /^[0-9]*$/
				var numRe = new RegExp(numReg)
				if (!numRe.test(this.topage)) {
					alert('请输入正确的数字');
					return;
				}
				if (this.topage < 0 || this.topage > this.pageTotal) {
					alert("请输入正确的页码范围");
					return;
				}
				if (this.topage == this.pageIndex+1) {
					return;
				}
				this.pageIndex = this.topage - 1;
				this.getEventByName();
			},
			laquo: function() {
				if (this.pageIndex == 0) {
					return
				} else {
					this.pageIndex--;
					this.getEventByName();
				}
			},
			raquo: function() {
				if (this.pageIndex == this.pageTotal-1) {
					return
				} else {
					this.pageIndex++;
					this.getEventByName();
				}
			},
			tofirst: function() {
				if (this.pageIndex == 0) {
					return;
				}
				this.pageIndex = 0;
				this.getEventByName();
			},
			tolast: function() {
				this.pageIndex = this.pageTotal-1;
				this.getEventByName();
			},
		},
		components: {
			BaiduMap,
			BmMarker,
			BmCircle,BmBoundary
		}
	})
</script>

<style>
	.bigimg{
		height: 100%;
		width: 100%;
		z-index: 100000;
		position: absolute;
		top:10px;
		bottom: 0px;
	}
	
	#event2{
		padding: 10px;
	}
	.event2_title:hover{
		cursor: pointer;
	}
	
	.event2_title{
		width:8%;
		height: 50px;
		background-color: #dc3545;
		font-size: 18px;
		color: white;
		border-radius: 10px;
	}
	
	.e2active{
		font-weight: bolder;
		background-color: #dc3545;
		box-shadow:0 0 10px black;
		
	}
	.merchants{
		height: 100%;
		overflow-y: scroll;
		width: 25%;
		background-color:white ;
	}
	
	.merchants::-webkit-scrollbar {
		display: none;
	}
	.ebody::-webkit-scrollbar {
		display: none;
	}
	.events{
		width: 70%;
		height: 100%;
	}
	.merlist{
		height: 50px;
		width: 95%;
		border-radius: 10px;
		background-color:#efefef;
		margin: 5px auto;
		color: #dc3545;
		font-size: 18px;
	}
</style>
